import { useMutation } from '@tanstack/react-query';
import { CRITICAL_INFORMATION_TAG } from '@/constants/documentTags.ts';
import { useUploadDocument } from '@/hooks/house/documents/mutations/useUploadDocument.ts';
import { makeLogger } from '@/utils/logger/logger.ts';

const logger = makeLogger('createCriticalInfo');

// Note: The api does not process very well for now names without extension,
// so it is important to keep the .json extension
const HOUSE_CRITICAL_INFORMATION_NAME = 'house-critical-information.json';

/**
 * Mutation hook for creating a new critical info document.
 * Uses useUploadDocument to POST to /documents endpoint.
 */
export const useCreateCriticalInfo = (houseId: number) => {
	const uploadDocument = useUploadDocument();

	return useMutation({
		mutationFn: async (documentData: unknown) => {
			const jsonBlob = new Blob([JSON.stringify(documentData)], { type: 'application/json' });
			const file = new File([jsonBlob], HOUSE_CRITICAL_INFORMATION_NAME, { type: 'application/json' });

			logger.info('Uploading critical info document', { houseId, fileName: HOUSE_CRITICAL_INFORMATION_NAME });
			const documentId = await uploadDocument.mutateAsync({
				houseId,
				file,
				tags: [CRITICAL_INFORMATION_TAG],
			});
			logger.info('Upload completed', { houseId, documentId });
			return documentId;
		},
	});
};
